import { Box, useTheme } from '@mui/material';
import EditActivityButton from 'src/components/domain/summary/edit-activity/EditActivityButton';
import { SummaryPriceLines } from './SummaryPriceLines';
import { SummaryCartItem } from './summary-mapping';

import type { JSX } from 'react';

interface IProps {
    invertedColorsClass?: Record<string, unknown>;
    onEditClick?: (e: React.MouseEvent) => void;
    summaryCartItem: SummaryCartItem;
}

export default function SummaryPriceDetailsForCartItem(props: IProps): JSX.Element {
    const { summaryCartItem } = props;
    const theme = useTheme();

    return (
        <Box m={theme.spacing(0.5, 0, 2, 0)}>
            <SummaryPriceLines
                invertedColorsClass={props.invertedColorsClass}
                lines={summaryCartItem.priceLines}
            />
            {props.onEditClick && (
                <EditActivityButton
                    invertedColorsClass={props.invertedColorsClass}
                    onEditClick={props.onEditClick}
                />
            )}
        </Box>
    );
}
